"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIS_FAILED = exports.VISUALIZING = exports.INITIALIZED = void 0;
var INITIALIZED = 'first_init';
exports.INITIALIZED = INITIALIZED;
var VISUALIZING = 'vis_loaded';
exports.VISUALIZING = VISUALIZING;
var VIS_FAILED = 'vis_failed';
exports.VIS_FAILED = VIS_FAILED;